import React from "react";
import {
  AnalyticsAudience,
  AnalyticsPlatform,
  SearchPreset,
} from "../../api/analyticsAdmin";

export interface SearchFilters {
  preset: SearchPreset;
  from: string;
  to: string;
  platform: AnalyticsPlatform;
  audience: AnalyticsAudience;
}

interface SearchFilterBarProps {
  filters: SearchFilters;
  onPresetChange: (preset: SearchPreset) => void;
  onCustomChange: (patch: Partial<Pick<SearchFilters, "from" | "to">>) => void;
  onPlatformChange: (platform: AnalyticsPlatform) => void;
  onAudienceChange: (audience: AnalyticsAudience) => void;
}

const PRESETS: { key: SearchPreset; label: string }[] = [
  { key: "Last3Days", label: "Last 3 days" },
  { key: "Last7Days", label: "Last 7 days" },
  { key: "Last30Days", label: "Last 30 days" },
  { key: "Custom", label: "Custom" },
];

const PLATFORMS: AnalyticsPlatform[] = ["All", "Web", "Native", "iOS", "Android"];
const AUDIENCES: AnalyticsAudience[] = ["All", "Anonymous", "Identified"];

export const SearchFilterBar: React.FC<SearchFilterBarProps> = ({
  filters,
  onPresetChange,
  onCustomChange,
  onPlatformChange,
  onAudienceChange,
}) => (
  <div className="flex flex-wrap items-end gap-4 mb-6">
    <div className="flex gap-2">
      {PRESETS.map((p) => (
        <button
          key={p.key}
          onClick={() => onPresetChange(p.key)}
          className={`px-4 py-2 text-sm rounded-lg border ${
            filters.preset === p.key
              ? "border-primary bg-primary/10 text-primary"
              : "border-gray-300 text-gray-600 hover:bg-gray-50"
          }`}
        >
          {p.label}
        </button>
      ))}
    </div>

    {filters.preset === "Custom" && (
      <div className="flex gap-2">
        <input
          type="date"
          value={filters.from}
          onChange={(e) => onCustomChange({ from: e.target.value })}
          className="p-2 border border-gray-300 rounded-lg text-sm"
        />
        <input
          type="date"
          value={filters.to}
          onChange={(e) => onCustomChange({ to: e.target.value })}
          className="p-2 border border-gray-300 rounded-lg text-sm"
        />
      </div>
    )}

    <select
      value={filters.platform}
      onChange={(e) => onPlatformChange(e.target.value as AnalyticsPlatform)}
      className="p-2 border border-gray-300 rounded-lg text-sm"
    >
      {PLATFORMS.map((p) => (
        <option key={p} value={p}>
          {p === "All" ? "All platforms" : p}
        </option>
      ))}
    </select>

    <select
      value={filters.audience}
      onChange={(e) => onAudienceChange(e.target.value as AnalyticsAudience)}
      className="p-2 border border-gray-300 rounded-lg text-sm"
    >
      {AUDIENCES.map((a) => (
        <option key={a} value={a}>
          {a === "All" ? "All audiences" : a}
        </option>
      ))}
    </select>
  </div>
);
